import { Actions, Button, Dialog, Stack, Text } from 'braid-design-system';

interface FreeToPaidUpsellDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onFreeClick: () => void;
  onCancelClick: () => void;
}

export const FreeToPaidUpsellDialog = (props: FreeToPaidUpsellDialogProps) => (
  <Dialog
    id="free-to-paid-upsell-dialog"
    title="Is Free right for you?"
    width="small"
    open={props.isOpen}
    onClose={props.onClose}
    data={{ testid: 'free-to-paid-upsell-dialog' }}
  >
    <Stack space="medium">
      <Text weight="medium">
        Free listings appear lower in search results and have a different
        appearance. They are also not included in the recommendation emails
        buyers receive daily for their saved search preferences.
      </Text>

      <Text>
        If you have a deadline in mind for selling your business, we recommend
        choosing Standard or Accelerate to maximise your exposure to the right
        buyers.
      </Text>
    </Stack>

    <Actions>
      <Button tone="formAccent" onClick={props.onFreeClick}>
        Continue with Free
      </Button>
      <Button tone="formAccent" variant="ghost" onClick={props.onCancelClick}>
        Choose another ad package
      </Button>
    </Actions>
  </Dialog>
);
